const Logo = ({ width = 99, height = 148, color = 'white', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 99 148"
      {...props}
    >
      <g id="Group 1426">
        <g id="Clip path group">
          <mask
            id="mask0_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="53"
            y="89"
            width="46"
            height="60"
          >
            <g id="clip-path">
              <path
                id="Vector"
                d="M90.7573 101.013C87.8162 103.001 84.5506 104.516 81.0914 105.497C75.0535 107.186 60.9591 111.257 58.0157 112.076C56.9843 112.303 56.038 112.793 55.2793 113.494C54.5206 114.196 53.9785 115.081 53.7119 116.054V143.23C53.7075 144.05 53.9268 144.857 54.3482 145.572C54.7697 146.287 55.379 146.886 56.1168 147.312C56.8546 147.737 57.6957 147.973 58.5584 147.998C59.421 148.023 60.2757 147.835 61.0391 147.453L96.0127 129.997C96.7885 129.609 97.438 129.027 97.8909 128.314C98.3439 127.601 98.583 126.784 98.5826 125.951V89.6372C98.4225 94.5776 94.5099 98.4286 90.7573 100.996"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask0_2632_86421)">
            <g id="Group">
              <path
                id="Vector_2"
                d="M98.518 87.9551L51.213 89.7515L53.784 150.804L101.089 149.007L98.518 87.9551Z"
                fill="url(#paint0_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <path
          id="Vector_3"
          d="M98.5613 77.8984V89.6541C98.4012 94.5945 94.4886 98.4456 90.736 101.013C87.7949 103.001 84.5293 104.516 81.07 105.497C75.0322 107.186 60.9378 111.257 57.9944 112.076C56.963 112.303 56.0167 112.793 55.258 113.494C54.4993 114.196 53.9572 115.081 53.6906 116.054C53.691 115.058 54.009 114.087 54.6028 113.267C55.1965 112.446 56.038 111.816 57.0163 111.46L78.6602 104.357C78.6602 104.357 98.5613 98.4456 98.5613 77.8984Z"
          fill="#FEDA2C"
        />
        <g id="Clip path group_2">
          <mask
            id="mask1_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="57"
            y="38"
            width="42"
            height="74"
          >
            <g id="clip-path-2">
              <path
                id="Vector_4"
                d="M82.2189 70.6863L79.4445 86.1241L76.4744 102.93C76.3913 103.415 76.1748 103.87 75.8469 104.249C75.519 104.629 75.0913 104.92 74.607 105.092L57.0447 111.46L78.6797 104.357C78.6797 104.357 98.5808 98.4456 98.5808 77.8985C98.5808 63.643 89.4128 51.6508 78.6086 44.2106C75.0732 41.7501 71.2137 39.74 67.1286 38.2314C86.834 46.2966 82.2455 70.6863 82.2455 70.6863"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask1_2632_86421)">
            <g id="Group_2">
              <path
                id="Vector_5"
                d="M98.5808 38.2314H57.0447V111.468H98.5808V38.2314Z"
                fill="url(#paint1_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_3">
          <mask
            id="mask2_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="67"
            y="38"
            width="18"
            height="65"
          >
            <g id="clip-path-3">
              <path
                id="Vector_6"
                d="M67.7953 38.5101C70.5073 39.6829 72.9605 41.3335 75.0248 43.3746C85.4377 53.6861 82.2187 70.6863 82.2187 70.6863L79.4443 86.124L76.4743 102.93L83.1791 73.3296C83.1791 73.3296 88.639 53.1878 78.6173 44.2106C77.4969 43.4506 76.3765 42.7327 75.2382 42.0656C72.8695 40.6699 70.3795 39.4691 67.7953 38.4763C67.5819 38.3919 67.3596 38.3075 67.1284 38.2314C67.3596 38.3159 67.5819 38.4088 67.7953 38.5101Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask2_2632_86421)">
            <g id="Group_3">
              <path
                id="Vector_7"
                d="M88.6392 38.2314H67.1376V102.93H88.6392V38.2314Z"
                fill="url(#paint2_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_4">
          <mask
            id="mask3_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="89"
            width="45"
            height="59"
          >
            <g id="clip-path-4">
              <path
                id="Vector_8"
                d="M5.2925e-05 125.934C-0.00403543 126.762 0.228811 127.574 0.673667 128.285C1.11852 128.996 1.75863 129.579 2.52547 129.971L37.5079 147.427C38.2714 147.81 39.1261 147.997 39.9887 147.973C40.8513 147.948 41.6925 147.711 42.4303 147.286C43.1681 146.861 43.7774 146.262 44.1988 145.546C44.6203 144.831 44.8395 144.024 44.8352 143.205V116.079C44.5655 115.106 44.0226 114.222 43.2645 113.52C42.5064 112.818 41.5617 112.324 40.5313 112.093C37.5879 111.248 23.5025 107.245 17.4557 105.522C14.0196 104.527 10.7785 103.003 7.86087 101.013C4.10831 98.4792 0.195678 94.5944 0.0356163 89.6455L5.2925e-05 125.934Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask3_2632_86421)">
            <g id="Group_4">
              <path
                id="Vector_9"
                d="M0.0120416 88.7185L-1.36328 149.062L44.8483 150.012L46.2236 89.6684L0.0120416 88.7185Z"
                fill="url(#paint3_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <path
          id="Vector_10"
          d="M0 77.8984V89.6457C0.160062 94.5946 4.07268 98.4456 7.82525 101.013C10.7645 103.002 14.0308 104.515 17.4912 105.489C23.538 107.22 37.6235 111.257 40.5579 112.068C41.59 112.298 42.5366 112.791 43.2963 113.493C44.0561 114.195 44.6003 115.08 44.8707 116.054C44.8721 115.057 44.5537 114.083 43.958 113.263C43.3623 112.442 42.5175 111.813 41.5361 111.46L19.901 104.357C19.901 104.357 0 98.4456 0 77.8984Z"
          fill="#FEDA2C"
        />
        <g id="Clip path group_5">
          <mask
            id="mask4_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="38"
            width="42"
            height="74"
          >
            <g id="clip-path-5">
              <path
                id="Vector_11"
                d="M19.9633 44.2103C9.1591 51.6505 0 63.6342 0 77.8981C0 98.4199 19.901 104.357 19.901 104.357L41.5361 111.459L23.9648 105.1C23.4788 104.927 23.0494 104.635 22.72 104.254C22.3905 103.873 22.1728 103.416 22.0886 102.93L19.1185 86.1237L16.3441 70.6859C16.3441 70.6859 11.7201 46.2962 31.4611 38.2227C27.3783 39.7395 23.5195 41.7521 19.9811 44.2103"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask4_2632_86421)">
            <g id="Group_5">
              <path
                id="Vector_12"
                d="M41.545 38.2227H0V111.459H41.545V38.2227Z"
                fill="url(#paint4_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_6">
          <mask
            id="mask5_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="15"
            y="36"
            width="68"
            height="71"
          >
            <g id="clip-path-6">
              <path
                id="Vector_13"
                d="M33.4007 37.5381C32.7604 37.7408 32.1202 37.952 31.4621 38.1884C11.7567 46.262 16.3452 70.6517 16.3452 70.6517L18.8173 84.4342C18.907 84.9303 19.145 85.3915 19.5028 85.7628C19.8607 86.1341 20.3234 86.3999 20.8358 86.5286L43.4312 92.2545C43.724 92.3592 43.9762 92.5463 44.1542 92.7908C44.3321 93.0352 44.4274 93.3254 44.4272 93.6226V101.544C44.4297 102.116 44.6296 102.67 44.9963 103.123L47.1927 105.589C47.4523 105.882 47.7762 106.118 48.1418 106.28C48.5074 106.441 48.9058 106.525 49.3091 106.525C49.7123 106.525 50.1107 106.441 50.4763 106.28C50.8419 106.118 51.1658 105.882 51.4254 105.589L53.6218 103.123C53.9885 102.67 54.1884 102.116 54.1909 101.544V93.6226C54.1901 93.3264 54.284 93.037 54.4603 92.7926C54.6365 92.5483 54.8868 92.3606 55.178 92.2545L77.7467 86.5624C78.2591 86.4352 78.7215 86.1696 79.0782 85.7979C79.4349 85.4262 79.6705 84.9643 79.7564 84.468L82.2374 70.6855C82.2374 70.6855 86.8525 46.2958 67.1204 38.2307C66.4713 37.9942 65.8221 37.7746 65.1819 37.5804C55.9161 34.709 49.2913 38.8978 49.2913 38.8978C46.4327 37.3248 43.1777 36.5191 39.8743 36.567C37.6658 36.5725 35.4721 36.9088 33.374 37.5635"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask5_2632_86421)">
            <g id="Group_6">
              <path
                id="Vector_14"
                d="M86.8384 34.7007H11.7427V106.839H86.8384V34.7007Z"
                fill="url(#paint5_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_7">
          <mask
            id="mask6_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="13"
            y="38"
            width="19"
            height="65"
          >
            <g id="clip-path-7">
              <path
                id="Vector_15"
                d="M19.9621 44.2103C9.94044 53.1791 15.4003 73.3293 15.4003 73.3293L22.0874 102.93L19.1173 86.1237L16.3429 70.6859C16.3429 70.6859 11.7189 46.2962 31.4599 38.2227C27.3771 39.7395 23.5183 41.7521 19.9799 44.2103"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask6_2632_86421)">
            <g id="Group_7">
              <path
                id="Vector_16"
                d="M31.4426 38.2227H9.94092V102.93H31.4426V38.2227Z"
                fill="url(#paint6_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_8">
          <mask
            id="mask7_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="27"
            y="1"
            width="45"
            height="80"
          >
            <g id="clip-path-8">
              <path
                id="Vector_17"
                d="M31.1163 9.89005C29.7299 10.5225 28.5966 11.5647 27.8864 12.8604C27.1762 14.1561 26.9273 15.6355 27.177 17.0769L29.7291 32.2107L30.5294 36.9653L35.4825 66.3714C35.7604 67.9915 36.599 69.4773 37.8656 70.594L49.2923 80.7282L49.3545 80.6691L60.71 70.6362C61.9794 69.5203 62.8211 68.0346 63.102 66.4136L67.9751 37.4889L68.8643 32.4894L69.7535 27.4223L71.532 17.1191C71.7769 15.6794 71.5247 14.2031 70.813 12.9108C70.1014 11.6184 68.9686 10.5795 67.5838 9.94918L49.4079 1.09863L31.1163 9.89005Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask7_2632_86421)">
            <g id="Group_8">
              <path
                id="Vector_18"
                d="M71.9041 1.04785H26.6688V80.6859H71.9041V1.04785Z"
                fill="url(#paint7_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_9">
          <mask
            id="mask8_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="25"
            y="0"
            width="48"
            height="83"
          >
            <g id="clip-path-9">
              <path
                id="Vector_19"
                d="M37.9665 70.3314C36.7009 69.2163 35.8677 67.7288 35.6012 66.1088L30.6926 36.9646L29.8923 32.2521L27.3669 17.2704C27.1306 15.8433 27.3822 14.3818 28.0848 13.1005C28.7874 11.8192 29.904 10.7855 31.2706 10.1511L49.2865 1.39345L67.3023 10.1595C68.6657 10.793 69.78 11.824 70.4823 13.1019C71.1847 14.3797 71.4383 15.8374 71.2061 17.2619L69.4899 27.4722L68.6006 32.4886L67.7647 37.4459L62.9896 66.1426C62.7288 67.7625 61.8982 69.2509 60.6331 70.3652L49.3754 80.3052L49.3132 80.3643L37.9665 70.3314ZM48.6373 0.295574L30.6837 9.05323C29.0544 9.79604 27.7229 11.0208 26.8891 12.5436C26.0553 14.0665 25.7643 15.8051 26.0597 17.4984L28.594 32.4717L29.3854 37.1926L34.3029 66.3284C34.6199 68.2144 35.5937 69.945 37.0684 71.2435L48.3883 81.2426L49.2776 82.028L50.1668 81.2511L50.2291 81.1919L61.4957 71.2435C62.9655 69.9414 63.9382 68.2126 64.2612 66.3284L69.0897 37.6739V37.5726L69.9078 32.7166L70.797 27.7002L72.5221 17.49V17.3886C72.787 15.7129 72.479 14.0007 71.6436 12.5034C70.8081 11.0062 69.4891 9.80285 67.8803 9.07011L49.8911 0.295574L49.2865 0L48.6373 0.295574Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask8_2632_86421)">
            <g id="Group_9">
              <path
                id="Vector_20"
                d="M73.0675 0H25.4757V82.0365H73.0675V0Z"
                fill="url(#paint8_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_10">
          <mask
            id="mask9_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="27"
            y="1"
            width="45"
            height="80"
          >
            <g id="clip-path-10">
              <path
                id="Vector_21"
                d="M31.115 9.88917C29.7302 10.5212 28.5981 11.5621 27.888 12.8561C27.1779 14.15 26.928 15.6275 27.1757 17.0676L29.7189 32.2098L30.5281 36.9644L35.4811 66.3705C35.4848 66.4296 35.4848 66.4888 35.4811 66.5479C35.5333 66.8334 35.6046 67.1155 35.6945 67.3924C36.1043 68.6138 36.8359 69.7156 37.8198 70.5931L49.2464 80.6767L49.3087 80.626L60.6642 70.5931C61.9336 69.4772 62.7753 67.9915 63.0562 66.3705L67.9292 37.4458L68.8185 32.4463L69.7077 27.3791L71.4862 17.076C71.729 15.6376 71.4758 14.1632 70.7643 12.8726C70.0528 11.582 68.9211 10.5444 67.538 9.91451L49.362 1.06396L31.115 9.88917Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask9_2632_86421)">
            <g id="Group_10">
              <path
                id="Vector_22"
                d="M71.9102 1.04639H26.6749V80.6844H71.9102V1.04639Z"
                fill="url(#paint9_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_11">
          <mask
            id="mask10_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="49"
            y="1"
            width="23"
            height="80"
          >
            <g id="clip-path-11">
              <path
                id="Vector_23"
                d="M49.2864 80.4733L49.3486 80.6337L60.7041 70.6009C61.9735 69.485 62.8152 67.9992 63.0962 66.3783L67.7735 38.6021L67.9692 37.4535L68.8584 32.454L69.7476 27.3869L71.5261 17.0837C71.7068 16.0135 71.6137 14.9176 71.2546 13.8887C70.8955 12.8598 70.2811 11.9281 69.4631 11.1721C69.4143 11.1199 69.3607 11.0719 69.303 11.0286C69.2394 10.9649 69.171 10.9056 69.0985 10.8512L68.8584 10.6654L68.565 10.4712L68.3338 10.3107L68.2448 10.26L68.0848 10.1756C68.0848 10.1756 68.0848 10.1756 68.0314 10.1756C67.9604 10.1312 67.8861 10.0917 67.8091 10.0574L67.6135 9.95601L49.4376 1.10547L49.2864 80.4733Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask10_2632_86421)">
            <g id="Group_11">
              <path
                id="Vector_24"
                d="M54.7809 -8.11031L13.2917 61.2231L66.2805 89.8229L107.77 20.4894L54.7809 -8.11031Z"
                fill="url(#paint10_linear_2632_86421)"
              />
            </g>
          </g>
        </g>
        <g id="Clip path group_12">
          <mask
            id="mask11_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="67"
            y="11"
            width="6"
            height="28"
          >
            <g id="clip-path-12">
              <path
                id="Vector_25"
                d="M71.4136 17.0598L69.6351 27.3629L68.7459 32.43L67.8566 37.4296L67.661 38.5781L68.7814 38.8906L72.0538 19.4667C72.5251 15.0245 70.7378 12.4487 69.235 11.106C70.0529 11.8619 70.6674 12.7936 71.0265 13.8225C71.3855 14.8515 71.4787 15.9473 71.298 17.0176"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask11_2632_86421)">
            <g id="Group_12">
              <g id="Group_13">
                <path
                  id="Vector_26"
                  d="M68.0323 10.1317L61.3058 37.4756L72.3895 39.9348L79.116 12.5909L68.0323 10.1317Z"
                  fill="url(#paint11_linear_2632_86421)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Clip path group_13">
          <mask
            id="mask12_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="26"
            y="11"
            width="5"
            height="28"
          >
            <g id="clip-path-13">
              <path
                id="Vector_27"
                d="M26.414 19.5167L29.6864 38.9407L30.8068 38.6282L30.6112 37.4796L29.7219 32.4801L28.8327 27.413L27.0542 17.1099C26.8736 16.0396 26.9667 14.9437 27.3258 13.9148C27.6848 12.8859 28.2993 11.9542 29.1173 11.1982C27.6145 12.541 25.8271 15.1168 26.2895 19.559"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask12_2632_86421)">
            <g id="Group_14">
              <g id="Group_15">
                <path
                  id="Vector_28"
                  d="M30.5634 10.125L19.4796 12.584L26.2068 39.9277L37.2906 37.4687L30.5634 10.125Z"
                  fill="url(#paint12_linear_2632_86421)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Clip path group_14">
          <mask
            id="mask13_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="35"
            y="67"
            width="15"
            height="16"
          >
            <g id="clip-path-14">
              <path
                id="Vector_29"
                d="M39.4025 73.3119L49.2819 82.0349L49.3531 80.6331L49.2908 80.6838L37.8642 70.6013C36.8802 69.7238 36.1487 68.6222 35.7389 67.4009C36.3827 69.6464 37.6477 71.6874 39.4025 73.3119Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask13_2632_86421)">
            <g id="Group_16">
              <g id="Group_17">
                <path
                  id="Vector_30"
                  d="M35.8545 66.2443L34.3695 81.9229L49.2485 83.1939L50.7335 67.5154L35.8545 66.2443Z"
                  fill="url(#paint13_linear_2632_86421)"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Clip path group_15">
          <mask
            id="mask14_2632_86421"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="49"
            y="67"
            width="14"
            height="16"
          >
            <g id="clip-path-15">
              <path
                id="Vector_31"
                d="M60.7113 70.6013L49.2847 80.6838L49.2224 80.6331L49.2935 82.0349L59.1818 73.3119C60.9314 71.6848 62.1929 69.6445 62.8366 67.4009C62.4338 68.6253 61.7012 69.7285 60.7113 70.6013Z"
                fill="white"
              />
            </g>
          </mask>
          <g mask="url(#mask14_2632_86421)">
            <g id="Group_18">
              <g id="Group_19">
                <path
                  id="Vector_32"
                  d="M62.7312 66.2488L47.8433 67.5205L49.3284 83.199L64.2163 81.9273L62.7312 66.2488Z"
                  fill="url(#paint14_linear_2632_86421)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2632_86421"
          x1="77.0007"
          y1="119.639"
          x2="95.2389"
          y2="118.871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.21" stopColor="#FDD32B" />
          <stop offset="0.5" stopColor="#FBC128" />
          <stop offset="0.85" stopColor="#F7A223" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2632_86421"
          x1="80.5279"
          y1="68.6997"
          x2="80.5279"
          y2="102.675"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2632_86421"
          x1="80.3384"
          y1="34.1789"
          x2="80.3384"
          y2="88.1099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2632_86421"
          x1="22.2759"
          y1="120.997"
          x2="5.6598"
          y2="120.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.21" stopColor="#FDD32B" />
          <stop offset="0.5" stopColor="#FBC128" />
          <stop offset="0.85" stopColor="#F7A223" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2632_86421"
          x1="23.5031"
          y1="68.6994"
          x2="23.5031"
          y2="102.674"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2632_86421"
          x1="48.1587"
          y1="47.7063"
          x2="48.1587"
          y2="98.4956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2632_86421"
          x1="22.8481"
          y1="34.1786"
          x2="22.8481"
          y2="88.1095"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2632_86421"
          x1="31.524"
          y1="39.1778"
          x2="65.5756"
          y2="39.1778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="1" stopColor="#BE1E2D" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2632_86421"
          x1="52.5265"
          y1="86.8333"
          x2="52.5265"
          y2="-14.8382"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.23" stopColor="#FDD62B" />
          <stop offset="0.47" stopColor="#FCC829" />
          <stop offset="0.73" stopColor="#F9B225" />
          <stop offset="0.99" stopColor="#F59420" />
          <stop offset="1" stopColor="#F59320" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2632_86421"
          x1="31.5212"
          y1="38.9963"
          x2="65.5728"
          y2="38.9963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="1" stopColor="#BE1E2D" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2632_86421"
          x1="255.847"
          y1="143.74"
          x2="39.6658"
          y2="14.3876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="1" stopColor="#BE1E2D" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2632_86421"
          x1="71.3948"
          y1="34.2886"
          x2="74.0039"
          y2="22.5296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2632_86421"
          x1="27.1818"
          y1="34.1794"
          x2="24.5467"
          y2="22.3015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2632_86421"
          x1="48.2364"
          y1="75.874"
          x2="39.7739"
          y2="75.0725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2632_86421"
          x1="52.7538"
          y1="75.8671"
          x2="61.216"
          y2="75.0624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDA2C" />
          <stop offset="0.19" stopColor="#F7C92A" />
          <stop offset="0.56" stopColor="#E49E23" />
          <stop offset="1" stopColor="#CB641B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Logo
